import { Icon } from '@assembly-js/design-system';
import { SvgIconProps } from '@mui/material';

export const ContractIcon = (props: SvgIconProps) => (
  <Icon icon="Contract" {...props} />
);
